// Grafica.js
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement,CategoryScale, LinearScale } from 'chart.js';
import ChartDataLabels from "chartjs-plugin-datalabels";
 
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ChartDataLabels);



   
const Grafica = ({ventas, options}) => { 
  
  return (
    <div className="p-6 w-full mx-auto bg-white rounded-lg shadow-lg">
      <Bar data={ventas} options={options} />
    </div>
  );
};

export default Grafica;
